import { HorizontalStack, Text, VerticalStack } from "@shopify/polaris";
import { Subheading } from "../..";
import { ToggleSwitch } from "@vendor-app/app/AdminRoute/AdminLoyaltyRoute/components/ToggleSwitch";

interface BundleOutOfStockAutoPauseEnabledSettingProps {
  bundleOutOfStockAutoPauseEnabled: boolean;
  setBundleOutOfStockAutoPauseEnabled: React.Dispatch<React.SetStateAction<boolean | null | undefined>>;
}

export function BundleOutOfStockAutoPauseEnabledSetting({
  bundleOutOfStockAutoPauseEnabled,
  setBundleOutOfStockAutoPauseEnabled,
}: BundleOutOfStockAutoPauseEnabledSettingProps) {
  return (
    <div className="Polaris-LegacyCard__Section" data-testid="bundle-out-of-stock-auto-pause-setting">
      <VerticalStack gap="1">
        <HorizontalStack gap="2" blockAlign="center">
          <Text as="h3" variant="headingSm">
            Auto-pause subscriptions on out of stock bundle items
          </Text>
          <ToggleSwitch
            defaultToggled={bundleOutOfStockAutoPauseEnabled}
            onHandleChangeCB={v => {
              setBundleOutOfStockAutoPauseEnabled(v);
            }}
          />
        </HorizontalStack>
        <Subheading className="card-subheading">
          {
            "When enabled, a subscription is automatically paused when an item in one of its bundles is out of stock, and resumed once it's back in stock. Customers will be notified, and you will see a record in the subscription log."
          }
        </Subheading>
      </VerticalStack>
    </div>
  );
}
